<template>
  <v-container class="ProfilInterface">
    <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
    >
      <v-toolbar v-if="item" class="my-md-auto " elevation="0" rounded="lg">
        <v-toolbar-title  class="hidden-md-and-down">
          <h2><v-icon large class="mr-2" >mdi-account-box-multiple</v-icon>{{ item['name'] }}</h2>
        </v-toolbar-title>
        <v-spacer />
        <div>
          <v-btn
              class="ml-2"
              :to="{ name: 'ProfilInterfaceList' }"
          >
            {{ $t('global.back')}}
          </v-btn>
          <v-btn
              class="ml-2"
              v-if="userHasAccess('profilinterface_edit')"
              color="primary"
              :to="{ name: 'ProfilInterfaceUpdate' , params: { id: item['@id'] } }"
          >
            {{ $t('global.update')}}
          </v-btn>
        </div>
      </v-toolbar>

      <div  v-if="item">
        <v-row>
          <v-col md="6">
            <v-divider></v-divider>
            <v-row>
              <v-col md="6" >
                <strong class="ml-4">{{ $t('global.name') }}:</strong>
              </v-col>
              <v-col md="6">
                <span class="mr-2">{{ item['name'] }}</span>
              </v-col>
            </v-row>

          </v-col>
          <v-col md="6">
            <v-divider></v-divider>
            <v-row>
              <v-col md="6" >
                <strong class="ml-4">{{ $t('administration.profil.base') }}:</strong>
              </v-col>
              <v-col md="6">
                <span v-if="item.base" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </v-col>
            </v-row>

          </v-col>

        </v-row>
        <v-row >
          <v-col md="3" >
            <v-divider></v-divider>
            <strong class="ml-4">{{ $t('administration.profil.blocs') }}:</strong>
          </v-col>
          <v-col md="9">
            <v-sheet
                max-width="400"
                class="secondary "
                elevation="12"

                width="100%"
            >
              <v-container >
                <v-row   justify="center">
                  <v-col v-if="hasPrinterList" cols="12" sm="6" md="6" >
                    <div class="m-5 primary">
                      <p class="m-5 text-center" >printerList</p>
                    </div>
                  </v-col>
                  <v-col cols="12" :sm="sizeorder" :md="sizeorder" >
                    <div v-for="bloc in item.blocs" :key="bloc" class="m-5 primary"  >
                      <p class="m-5 text-center" v-if="bloc === 'orderListDoubleRole'">{{ bloc }}</p>
                      <p class="m-5 text-center" v-if="bloc === 'orderListNew'">{{ bloc }}</p>
                      <p class="m-5 text-center" v-if="bloc === 'orderList'">{{ bloc }}</p>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
          </v-col>


        </v-row>
      </div>


    </v-sheet>
    <Loading :visible="isLoading" />
  </v-container>

</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import ListMixin from '../../mixins/ListMixin';


const servicePrefix = 'Profil';

export default {
  name: 'ProfilUserShow',
  servicePrefix,
  components: {
    Loading,

  },
  mixins: [ShowMixin,AccessMixin,ListMixin],
  data() {
    return {
      headers: [
        { text: this.$t('administration.user.login'), value: 'login' },
        { text: this.$t('administration.user.firstname'), value: 'firstname' },
        { text: this.$t('administration.user.lastname'), value: 'lastname' },
        { text: this.$t('administration.user.enabled'), value: 'enabled' },
      ],
      filters: {
        'profil' : this.$route.params.id,
      },
      selected: [],
    };
  },
  computed: {
    ...mapFields('profil', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('profil', ['find']),
    ...mapGetters('accesses', {
      Accessitems: 'list'
    }),
    ...mapGetters('user', {
      useritems: 'list'
    }),
    ...mapFields('user', {
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    hasPrinterList() {
      for (let i = 0; i < this.item.blocs.length; i++) {
        if (this.item.blocs[i] == 'printerList') {
          return true;
        }
      }
      return false;
    },
    sizeorder() {
      if (this.hasPrinterList) return 6;
      else return 10;
    }
  },
  methods: {
    ...mapActions('profil', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('accesses', {
      fetchAll: 'fetchAll',
    }),
    ...mapActions('user', {
      getPage: 'fetchAll',
    }),
    hasAccess (access) {
      if (access) {
        for (var i = 0; i < this.item.access.length; i++) {
          if (access['@id'] == this.item.access[i]['@id']) {
            return true;
          }
        }
      }
      return false;
    },
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'User',value);
    }
  },
  mounted() {
    this.fetchAll({'pagination' : false});

  },

};
</script>
